<template>
    <div class="section" :id="id">
        <div class="">
            <h5 v-if="title" class="card-title">{{title}}</h5>
            <p v-if="text" class="card-text">{{text}}</p>
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Section",
        props: ["id", "title", "text"]
    }
</script>

<style lang="scss" scoped>

    .section {
        margin-bottom: 1em;
    }

    .div {
        display: contents;
    }
</style>
